import { RelevantExamsActionType } from "../types/AddRelevantExamsActionType";

import  relevantExamsService  from "../services/relevantExamsService";

import { questionActions } from "../reducers/questionCreateReducer";


const getRelevantExams = (data: any) => (dispatch: any) => {
    relevantExamsService.getRelevantExams()
    .then(
        (res: any) => {dispatch(questionActions.setAllRelevantExams(res))}
    )
}

export {
    getRelevantExams
};